export default "__VITE_PUBLIC_ASSET__c261fb5e__"